import { Component, OnInit } from '@angular/core';
import { AppInformationService, GenesisUnitOfWork } from 'app/core/core.module';
import { EmailTemplate, SalesRep } from 'app/core/model/entity-model';
import { default as validationEngine } from 'devextreme/ui/validation_engine';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-email-template-dialog',
    templateUrl: './email-template-dialog.component.html',
    styleUrls: ['./email-template-dialog.component.scss'],
    standalone: false
})
export class EmailTemplateDialogComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    emailTemplate: EmailTemplate;
    displayOrder: number;
    validationGroup: 'emailTemplateValidationGroup';

    constructor(
        public modalRef: BsModalRef,
        private uow: GenesisUnitOfWork,
        private appInfo: AppInformationService
    ) {}

    async ngOnInit() {

        await this.getData();
    }

    async getData() {
        if (!this.emailTemplate){
            this.emailTemplate = this.uow.emailTemplates.createEntity({
                displayOrder: this.displayOrder
            }) as EmailTemplate;
        }
    }

    async save() {
        if (!this.validate()) return;
        this.result.next({ success: true });
    }

    close() {
        this.uow.rollback();
        this.result.next({ success: false });
    }

    validate() {
        const groupConfig = validationEngine.getGroupConfig('emailTemplateValidationGroup');
        if (groupConfig) {
            const result = validationEngine.validateGroup('emailTemplateValidationGroup');
            if (!result.isValid) {
                let message = '';
                result.brokenRules.forEach((brokenRule) => {
                    if (brokenRule.type === 'custom') message = `${brokenRule.message}\n${message}`;
                });
                this.appInfo.notifyToast(`Please fix errors before saving.\n\n${message}`, 'error');
                return false;
            }
        }
        return true;
    }
}
